import * as UserActions from "user/user/actions";
import { createDefaultDto, LoginUserType } from "user/user/dto";
import * as ExternalActions from "external/container/actions";
import * as Api from "external/reports/officeStats/api";
// Helpers
import { notifier } from "common/notifier";
//-------------------------------------------------------------------------------------------------------------------------------
export const RECIEVED = "EXTERNAL_OFFICE_RECIEVED";
export function recievedData(officeId) {
    return {
        type: RECIEVED,
        officeId: officeId
    };
}
//-------------------------------------------------------------------------------------------------------------------------------
export const getOfficeData = (officeGuid) => {
    return (dispatch) => {
        // Dispatch that we are fetching the report
        dispatch(ExternalActions.createAction_ExternalFetching(true));
        // Fetch
        Api.async_Request(dispatch, officeGuid)
            .then((officeData) => {
            let officeId = officeData.officeId;
            dispatch(recievedData(officeId));
            let defaultDto = createDefaultDto();
            defaultDto.loginUserType = LoginUserType.FeedProvider;
            dispatch(UserActions.createAction_User_SetData(defaultDto));
            dispatch(ExternalActions.createAction_ExternalFetching(false));
        }, (message) => {
            dispatch(ExternalActions.createAction_ExternalFetching(false));
            notifier.notifyError("Error", message);
        });
    };
};
